import { DEFAULT_MAP_LOCATION, DEFAULT_MAP_ZOOM } from '@bikemap/js/settings'
import { MAP_BOUNDS_UPDATE, MAP_MOVE, MAP_ZOOM, SET_MAP_VIEWPORT } from '../actions'
import { UPDATE_GEONAME_INFO } from '../../geolocation/actions'

/**
 * @typedef {object} MapViewportState
 * @property {import('@bikemap/js/map').LngLat} center
 * @property {number} zoom
 * @property {import('@bikemap/js/map').LngLatBounds|null} bounds
 */

/** @type {MapViewportState} */
const initialState = {
    center: DEFAULT_MAP_LOCATION,
    zoom: DEFAULT_MAP_ZOOM,
    bounds: null,
}

/**
 * @param {MapViewportState} [state]
 * @param {Object} action
 * @returns {MapViewportState}
 */
export default function mapViewport(state = initialState, action) {
    switch (action.type) {
        case MAP_MOVE:
            return {
                ...state,
                center: action.payload.center,
            }

        case MAP_ZOOM:
            return {
                ...state,
                zoom: action.payload.zoom,
            }

        case SET_MAP_VIEWPORT:
            return {
                ...state,
                ...action.payload.viewport,
            }

        case UPDATE_GEONAME_INFO:
            return action.center ? {
                ...state,
                center: action.center,
                zoom: DEFAULT_MAP_ZOOM,
            } : state

        case MAP_BOUNDS_UPDATE:
            return {
                ...state,
                bounds: action.payload.bounds,
            }

        default:
            return state
    }
}
